import { ReactNode } from 'react';

import { useTranslation } from 'react-i18next';

export type ValidationHeaderProps = {
  sessionId: string;
  location?: string;
  date?: string;
  headerExtra?: ReactNode;
};

const formatSessionId = (id: string) => {
  if (!id) return '';
  return id.slice(0, 8).toUpperCase();
};

export const ValidationHeader = ({
  sessionId,
  location,
  date,
  headerExtra,
}: ValidationHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between gap-2">
      <div>
        <h1 className="text-lg font-semibold sm:text-2xl">
          <span>{t('fertWork.sessionPrefix', 'Session - ')}</span>
          <span title={sessionId}>{formatSessionId(sessionId)}</span>
        </h1>
        {(location || date) && (
          <p className="text-xs text-gray-600 sm:text-sm">
            {location && <span>{location}</span>}
            {location && date && <span> - </span>}
            {date && <span>{date}</span>}
          </p>
        )}
      </div>
      {headerExtra}
    </div>
  );
};
